export const cibHexo = ["32 32","<path d='M16 0.011l-13.907 8.063v15.995l13.907 7.927 13.907-8.068v-15.989zM22.396 22.817l-1.251 0.693-1.249-0.693v-5.563h-7.792v5.563l-1.249 0.693-1.251-0.693v-13.629l1.251-0.699 1.249 0.699v5.561h7.792v-5.561l1.249-0.699 1.251 0.699z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-hexo.js
// module id = null
// module chunks = 